module.exports = __webpack_public_path__ + "img/lambdoge.2a99d278.png";